export let ResellerCapabilities = /*#__PURE__*/function (ResellerCapabilities) {
  ResellerCapabilities["ADD_RESELLER_DOMAIN"] = "add_reseller_domain";
  ResellerCapabilities["BLOCK_DOMAIN_TRANSFER"] = "block_domain_transfer";
  return ResellerCapabilities;
}({});
export let ResellerProductTypeIds = /*#__PURE__*/function (ResellerProductTypeIds) {
  ResellerProductTypeIds["DOMAIN"] = "72af0602-1321-4897-8299-f507480b2bb8";
  return ResellerProductTypeIds;
}({});
//# sourceMappingURL=reseller.js.map